module.exports = __webpack_public_path__ + "static/media/maf-39.f73e96d7.png";